/**
 * Valida se um codigo de barras esta valido e no formato EAN
 * @param codigoBarra
 * @returns false caso seja invalido e true caso seja valido
 */
export function validarCEAN(codigoBarra: string) : boolean {
  var tamCean = codigoBarra.length;
  if(tamCean === 8) return validarCEAN8(codigoBarra);

  else if(tamCean === 12) return validarCEAN12(codigoBarra);

  else if(tamCean === 13) return validarCEAN13(codigoBarra);

  else if(tamCean === 14) return validarCEAN14(codigoBarra);

}

/**
 * Valida se um codigo de barras esta valido e no formato EAN-8
 * @param codigoBarra
 * @returns false caso seja invalido e true caso seja valido
 */
function validarCEAN8(codigoBarra: string) : boolean {
  var factor = 3;
  var sum = 0;

  for(var index = codigoBarra.length; index > 0; --index){
    if(index !== 8){
      sum += Number(codigoBarra.substring(index-1, index)) * factor;
      factor = 4 - factor;
    }
  }

  var cc = ((1000 - sum) % 10);
  var ca = Number(codigoBarra.substring(7));

  if(cc === ca){
    return true
  }

  else{
    return false;
  }
}

/**
 * Valida se um codigo de barras esta valido e no formato EAN-12
 * @param codigoBarra
 * @returns false caso seja invalido e true caso seja valido
 */
function validarCEAN12(codigoBarra: string) : boolean {
  var factor = 3;
  var sum = 0;

  for(var index = codigoBarra.length; index > 0; --index){
    if(index !== 12){
      sum += Number(codigoBarra.substring(index-1, index)) * factor;
      factor = 4 - factor;
    }
  }

  var cc = ((1000 - sum) % 10);
  var ca = Number(codigoBarra.substring(11));

  if(cc === ca){
    return true
  }

  else{
    return false;
  }
}

/**
 * Valida se um codigo de barras esta valido e no formato EAN-13
 * @param codigoBarra
 * @returns false caso seja invalido e true caso seja valido
 */
function validarCEAN13(codigoBarra: string) : boolean {
  var factor = 3;
  var sum = 0;

  for(var index = codigoBarra.length; index > 0; --index){
    if(index !== 13){
      sum += Number(codigoBarra.substring(index-1, index)) * factor;
      factor = 4 - factor;
    }
  }

  var cc = ((1000 - sum) % 10);
  var ca = Number(codigoBarra.substring(12));

  if(cc === ca){
    return true
  }

  else{
    return false;
  }
}

/**
 * Valida se um codigo de barras esta valido e no formato EAN-14
 * @param codigoBarra
 * @returns false caso seja invalido e true caso seja valido
 */
function validarCEAN14(codigoBarra: string) : boolean {
  var factor = 3;
  var sum = 0;

  for(var index = codigoBarra.length; index > 0; --index){
    if(index !== 14){
      sum += Number(codigoBarra.substring(index-1, index)) * factor;
      factor = 4 - factor;
    }
  }

  var cc = ((1000 - sum) % 10);
  var ca = Number(codigoBarra.substring(13));

  if(cc === ca){
    return true
  }

  else{
    return false;
  }
}
